module.exports = __webpack_public_path__ + "img/stepbg.ea12a7f1.png";